import React, { useEffect, useState } from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import api from "../../utils/api"
import { graphql, Link, navigate } from "gatsby"
import { Map, Marker } from "../../components/Map"
import { Sticky, StickyContainer } from "react-sticky"
import SearchParams from "../../components/SearchParams"
import updateQueryString from "../../components/SearchParams/updateQs"
import qs from "query-string"
import ProgressDots from "../../components/ProgressDots"
import MonthlySpaceBlock, { profileUrl } from "./_MonthlySpaceBlock"
import replace from "../../utils/replace"
import SearchResultsForm from "../../components/SearchResultsForm"
import Onboard from "./_onboard"
import { mapCenter } from "../index"
import { cities } from "../../config"
import isOnDemand from "../../utils/isOnDemand"
import getUserIdForAnalytics from "./_getUserIdForAnalytics"

import "./styles.less"

const LocationsPage = ({ data, location = {} }) => {
  const cmsLocations = data.cms.locations
  const pageData = data.cms.pageData

  const [progress, setProgress] = useState(false)

  const [isFirst, setIsFirst] = useState(false)
  const [hoveredSpace, setHoveredSpace] = useState("")

  const [hqSuites, setHqSuites] = useState(false)
  const [user, setUser] = useState({})

  const [city, setCity] = useState(cities[0])
  const [teamSize, setTeamSize] = useState(0)

  const [filteredSpaces, setFilteredSpaces] = useState([])
  const [userId, setUserId] = useState(null)
  const [isApi, setIsApi] = useState(false)
  const globals = data.cms.globals

  const displayPrice = isOnDemand() ? true : Number(teamSize) < 12

  useEffect(() => {
    setProgress(false)
    if (!location.search) {
      navigate("/locations?location=Toronto")
      return
    }
    setFilteredSpaces([])
    const searchParams = qs.parse(location.search)
    setIsFirst(!!searchParams.onboard)
    const selectedCity = searchParams.location || cities[0]
    setTeamSize(searchParams.current_staff)

    setCity(selectedCity)

    setIsApi(false)
    setHqSuites(false)

    const teamSize = searchParams.current_staff || ""

    const tsArray = teamSize.split("-")
    const tsMin = tsArray?.[0] || 0
    const tsMax = tsArray?.[1] || tsArray?.[0] || 0

    if (tsMin || searchParams.move_in_date) {
      if (Number(tsMax) <= 50) {
        // do the matching
        setProgress(true)
        fetchResults(searchParams)
        setIsApi(true)
      } else {
        setHqSuites(true)
        setSpacesFromCms(selectedCity)
      }
    } else {
      // revert to CMS locations
      setSpacesFromCms(selectedCity)
    }
  }, [location.search])

  const setSpacesFromCms = (city) => {
    setFilteredSpaces(
      cmsLocations.filter((space) => space.location.parts.city === city)
    )
  }

  useEffect(() => {
    if (userId) {
      return
    }
    setUserId(getUserIdForAnalytics())
  }, [])

  const fetchResults = async (searchParams) => {
    api("results", {
      params: searchParams,
      show_test_space: null,
      analytics_user_id: process.env.GATSBY_USER_ID_FOR_WS_ANALYTICS,
      space_operator_id: process.env.GATSBY_SO_ID,
      userId: userId,
    })
      .then((res) => {
        setUser(res.data.user)
        setFilteredSpaces(res.data.scores)
        setProgress(false)
      })
      .catch(function (error) {
        console.log(error)
        return false
      })
  }

  return (
    <Layout
      mainClassName={`pb-4 pb-sm-3 pb-lg-0 ${
        teamSize ? "" : "fixed-bar-wrapper"
      }`}
    >
      {isFirst && <Onboard />}
      <SEO
        title={pageData?.metaTitle}
        description={pageData?.metaDescription}
        image={
          pageData?.metaImage[0]
            ? pageData?.metaImage[0].url
            : globals?.metaImage[0].url
        }
        jsonSchema={pageData?.jsonSchema}
      />

      <LocationImage city={city} className={"location-city-image d-md-none"} />

      <div className="location-buttons pt-0 d-md-none">
        {cities.length > 1 &&
          cities.map((c) => (
            <button
              key={c}
              className={`btn switcher ${city === c ? "active" : ""}`}
              onClick={() => updateQueryString("location", c)}
            >
              {c}
            </button>
          ))}
      </div>

      <StickyContainer>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 d-flex">
              <div className="location-page-list-container">
                <div className="location-buttons">
                  <div className="d-none d-md-block location-buttons">
                    {cities.length > 1 &&
                      cities.map((c) => (
                        <button
                          key={c}
                          className={`btn switcher ${
                            city === c ? "active" : ""
                          }`}
                          onClick={() => updateQueryString("location", c)}
                        >
                          Toronto
                        </button>
                      ))}
                  </div>

                  <LocationImage
                    city={city}
                    className={"location-city-image d-none d-md-block"}
                  />

                  <SearchParams locationSearch={location.search} />
                </div>

                {!progress && (isApi || hqSuites) && (
                  <SearchResultsForm
                    hqSuites={hqSuites}
                    resultsCount={
                      filteredSpaces && filteredSpaces.length > 0
                        ? filteredSpaces.length
                        : 0
                    }
                    teamSize={teamSize}
                    searchParams={qs.parse(location.search)}
                    activeSpaces={filteredSpaces}
                    cmsLocations={cmsLocations}
                    pageData={pageData}
                    emailTitleOverride={"Workplace One - Inquiry"}
                  />
                )}

                <div className="location-list">
                  {progress && <ProgressDots active={progress} />}
                  {!progress &&
                    filteredSpaces.map((item, idx) => {
                      return (
                        <LocationBox
                          key={idx}
                          isHqSuite={isHqSuite(item)}
                          cmsLocation={isApi ? null : item}
                          isApi={isApi}
                          apiLocation={isApi ? item : null}
                          user={user}
                          teamSize={teamSize}
                          hqSuites={hqSuites}
                          setHoveredSpace={setHoveredSpace}
                          displayPrice={displayPrice}
                        />
                      )
                    })}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <Sticky>
                {({ style }) => (
                  <div
                    style={style}
                    className="locations-page-map-container d-none d-lg-block"
                  >
                    <Map
                      center={mapCenter[city.toLowerCase()]}
                      defaultZoom={13}
                    >
                      {filteredSpaces.map((item, idx) => {
                        return (
                          <Marker
                            key={idx}
                            isHqSuite={isHqSuite(item)}
                            slug={isApi ? null : `/locations/${item.slug}`}
                            url={isApi ? profileUrl(item.space_id, user) : null}
                            id={idx}
                            text={item.name ? replace(item.name) : item.title}
                            lat={item.location.lat}
                            lng={item.location.lng}
                            priceRange={
                              displayPrice && item.price_min
                                ? `$${item.price_min.toLocaleString("en-US")}${
                                    item.price_min < item.price_max ? "+" : ""
                                  }`
                                : null
                            }
                            isActive={
                              !!(
                                hoveredSpace &&
                                (hoveredSpace === item.id ||
                                  hoveredSpace === item.space_id)
                              )
                            }
                          />
                        )
                      })}
                    </Map>
                  </div>
                )}
              </Sticky>
            </div>
          </div>
        </div>

        {/*<FixedBar />*/}
      </StickyContainer>
    </Layout>
  )
}

export default LocationsPage

const LocationImage = ({ city, className = "" }) => {
  return (
    <div className={`location-city-image ${className}`}>
      <img
        src={require("../../images/ls-toronto.jpg").default}
        alt="Toronto"
        className={city === "Toronto" ? "d-block" : "d-none"}
      />
      <img
        src={require("../../images/ls-kitchener.jpg").default}
        alt="Kitchener"
        className={city === "Kitchener" ? "d-block" : "d-none"}
      />
      <span>{city}</span>
    </div>
  )
}

const validHqSuite = (space = {}, teamSize = 1, city = "") => {
  if (space.location.parts.city !== city) {
    return false
  }
  const hq =
    typeof space.hasHqSuites === "object" && space.hasHqSuites.length > 0
      ? space.hasHqSuites
      : null
  if (!hq) {
    return false
  }
  const valid = hq.find((item) => {
    return item === teamSize
  })
  return valid
}

const LocationBox = ({
  cmsLocation,
  isApi,
  apiLocation,
  selectedCity = "Toronto",
  user = {},
  hqSuites = false,
  teamSize,
  setHoveredSpace = () => null,
  displayPrice = false,
  isHqSuite = false,
}) => {
  const setActiveSpace = (id) => {
    setHoveredSpace(
      typeof window !== "undefined" && window.innerWidth >= 992 ? id : ""
    )
  }
  if (hqSuites && !validHqSuite(cmsLocation, teamSize, selectedCity)) {
    return null
  }
  if (isApi) {
    return (
      <MonthlySpaceBlock
        location={apiLocation}
        user={user}
        city={selectedCity}
        onMouseEnter={() => setActiveSpace(apiLocation.space_id)}
        onMouseLeave={() => setHoveredSpace()}
        displayPrice={displayPrice}
      />
    )
  }
  return (
    <Link
      className="location-box"
      to={`/locations/${cmsLocation.slug}${hqSuites ? "#hq-suites" : ""}`}
      onMouseEnter={() => setActiveSpace(cmsLocation.id)}
      onMouseLeave={() => setHoveredSpace()}
    >
      <div className="row">
        <div className="col-sm-6">
          <div className="img">
            <img
              src={cmsLocation.mainImage[0].url}
              alt={cmsLocation.mainImage[0].title}
            />
          </div>
        </div>
        <div className="col-sm-6">
          <span className={"address d-sm-none"}>
            {cmsLocation.shortAddress}
          </span>
          <h4>
            <span className={isHqSuite ? "wp1-hq-suite-dot" : ""}>
              {cmsLocation.title}
            </span>
          </h4>
          <span className={"address d-none d-sm-block"}>
            {cmsLocation.shortAddress}
          </span>
          {!hqSuites && cmsLocation.availableSolutions.length > 0 && (
            <p className={"available-solutions"}>
              {cmsLocation.availableSolutions.map((sol, idx) => (
                <span key={idx}>{sol.title}</span>
              ))}
            </p>
          )}
        </div>
      </div>
    </Link>
  )
}

const isHqSuite = (item = {}) => {
  return item.hasHqSuites && item.hasHqSuites.length > 0 && !item.locationsUuid
}

export const query = graphql`
  query {
    cms {
      locations: entries(section: "locations") {
        id
        ... on Cms_locations_locations_Entry {
          id
          slug
          locationsUuid
          location {
            lng
            lat
            parts {
              city
              address
              number
            }
          }
          shortAddress
          title
          hasHqSuites
          mainImage {
            url(width: 600, height: 360)
            title
          }
          availableSolutions {
            ... on Cms_solutions_solutions_Entry {
              title
            }
          }
        }
      }
      pageData: entry(section: "locationsPage") {
        id
        ... on Cms_locationsPage_locationsPage_Entry {
          id
          metaTitle
          metaDescription
          jsonSchema
          metaImage {
            url(width: 1200, height: 630)
          }
          noResultsFormTitle
          noResultsFormText
          teamSuitesFormTitle
          teamSuitesFormText
          hqSuitesFormTitle
          hqSuitesFormText
          formEmail: locationTitle
        }
      }
      globals: globalSet {
        id
        ... on Cms_metadata_GlobalSet {
          id
          metaImage {
            url(width: 1200)
          }
        }
      }
    }
  }
`
